import { useAppDispatch } from "../../../redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSurveyHistory,
  updatePageIndex,
} from "../../../redux/reducer/surveyHistoryReducer";
import Row from "./Row";
import TableHeader from "./tableHeader";
import Pagination from "../../pagination";
import { deleteSurveyAnswersById } from "../../../redux/reducer/surveyReducer";

const SurveyHistory = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  /**
   * Get url params.
   */
  const { id } = useParams();

  /**
   * Get state variables from redux store
   */
  const { surveysHistory, citizens } = useSelector((state: any) => state);
  const { eventId } = useSelector((state: any) => state.login);
  const { surveysHistoryList, pageIndex, pageTotal } = surveysHistory;
  const { editCitizen } = citizens;

  /**
   * update survey history table pagination and refetch on page change
   */
  const setPageIndex = (newpage: any) => {
    dispatch(updatePageIndex(newpage));
    dispatch(getSurveyHistory(id));
  };

  /**
   * handle survey answers deletion.
   */
  const handleSurveyAnswerDelete = async (surveyAnswersId: string) => {
    if (eventId && id && surveyAnswersId) {
      const result = await dispatch(
        deleteSurveyAnswersById(eventId, id, surveyAnswersId)
      );
      const params = result?.id ? `notification=success` : `notification=error`;
      if (result?.id) dispatch(getSurveyHistory(id));
      navigate(`/enrollment/citizen-detail/${id}?${params}&type=deleteSurvey`);
    }
  };

  return (
    <div className="container-box mb-3">
      <div className="survey-wrapper-box survey-list pt-0">
        {surveysHistoryList.length > 0 ? (
          <>
            <table className="table">
              <TableHeader />
              <tbody>
                {surveysHistoryList.map((rowItem: any, key: any) => (
                  <Row
                    surveyDataRow={rowItem}
                    key={key}
                    handleDelete={handleSurveyAnswerDelete}
                  />
                ))}
              </tbody>
            </table>
            <div className="col-12 mt-2 mb-2">
              <Pagination
                onPageChange={setPageIndex}
                pageIndex={pageIndex}
                pageTotal={pageTotal}
              />
            </div>
          </>
        ) : (
          <div className="col-lg-4 mx-auto  text-center">
            <div className="no-survey-text">
              <span className="material-symbols-outlined">inventory</span>
              <h3>{t("no-survey-found")}</h3>
              <h4 className="mb-3">
                {editCitizen.name} {editCitizen.surname}
              </h4>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SurveyHistory;
